import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import Header from './components/Header';
import Home from './components/Home';
import Cart from './components/Cart';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/ShoppingCart-Frontend" element={<Home/>} exact></Route>
          <Route path="/ShoppingCart-Frontend/cart" element={<Cart/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;